import React from 'react';
;
import propTypes from 'prop-types';
import classNames from 'classnames';
import { FadeInDiv } from '../logic';
import { usePoseWithBulma } from '../hooks';
import { ModalBackground } from 'src/ui/mui-ui-kit'

export function InnerLoader({ visible, className = '', style = {} }) {
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    visible
  );

  const loaderClassNames = classNames('inner-loader', {
    'is-active': isModalVisible,
  });

  return (
    <div className={classNames(loaderClassNames, className)} style={style}>
      <ModalBackground
        tag={FadeInDiv}
        pose={currentPose}
        onPoseComplete={onPoseComplete}
      />
    </div>
  );
}

// eslint-disable-next-line react/require-default-props
InnerLoader.propTypes = {
  visible: propTypes.bool.isRequired,
  className: propTypes.string,
  style: propTypes.object,
};


